import { registrationTimes as schemaRegistrationTimes } from './schemas';
import apiClient from './apiClient';
import RegistrationTimesDataStore from '../../datastores/RegistrationTimesStore';

class RegistrationTimesDataStoreGraphQL implements RegistrationTimesDataStore {
  async getRegistrationTimes(
    courseId: string,
    campus: string,
    career: string,
    plan: string,
    prog: string,
    period: string
  ) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaRegistrationTimes.getRegistrationTimes,
        fetchPolicy: 'cache-first',
        variables: {
          courseId,
          campus,
          career,
          plan,
          prog,
          period
        }
      });
      return response.data?.coursesSchedules?.getSchedules;
    } catch (error) {
      throw new Error('Error fetching registration times');
    }
  }
}

export default RegistrationTimesDataStoreGraphQL;
